import { initI18n } from '@pasteltech/react-i18n'
import { languagePack, Languages } from '@carsland-web/language-pack'

export async function init(): Promise<void> {
  // Only zh-Hant is supported for now
  const userDefaultLanguage = Languages.traditionalChinese

  await initI18n(languagePack, userDefaultLanguage, {
    languageDetector() {
      return {
        type: 'languageDetector',
        async: true,
        detect(cb) {
          cb(userDefaultLanguage)
        },
      }
    },
  })
}
